module.exports = "<documents-grid \r\n    [allReports]=\"reports | async\" \r\n    [category]=\"selectedCategory | async\">\r\n</documents-grid>"